import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function submitLead(payload) {
  const res = await axios.post(`${API}/leads`, payload);
  return res.data;
}

export async function submitLeadWithFiles(formData) {
  const res = await axios.post(`${API}/leads/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    maxBodyLength: 130 * 1024 * 1024,
    maxContentLength: 130 * 1024 * 1024,
  });
  return res.data;
}
